<template>
  <el-scrollbar class="spectaculars-box">
    <div class="spectaculars-header">
      <div class="header-title">
        <span>数据看板</span>
      </div>
      <div class="header-title-img">
        <div class="img-box">
          <img class="" src="./../../assets/img/spectaculars/bottomImg.png" alt="">
          <div class="dimensionality-class">
            <div v-for="item in dimensionalityClass" @click="selectDimensionality(item.id)" class="dimensionality-item" :class="{dimensionalityItemActive : dimensionality === item.id}">{{item.name}}</div>
          </div>
          <div class="header-quadrangle">
            <div class="quadrangle"></div>
            <div class="quadrangle"></div>
            <div class="quadrangle"></div>
          </div>
          <i class="iconfont quadrangle-look" @click="lookPitchOnClick">&#xe6b9;</i>
          <i class="iconfont quadrangle-set" @click="setPitchOnClick">&#xeb6b;</i>
          <!--    查看选中      -->
          <div class="look-pitch-on" v-if="lookPitchOnShow">
            <i class="iconfont closeIcon" @click="lookPitchOnShow = false">&#xe623;</i>
            <div class="mid-right-icon">
              <i class="iconfont">&#xe674;</i>
              <i class="iconfont">&#xe674;</i>
            </div>
            <div class="pitch-on-left">
              <div class="left-icon">
                <i class="iconfont">{{role == 1 ? '&#xe681;' : '&#xe904;' }}</i>
              </div>
              <el-scrollbar class="left-list-scrollbar">
                <div class="left-list" v-if="examineShowList.length">
                  <div class="left-list-item" :class="{listItemActive : lookLeftActive === item.id}" @click="lookPitchSchool(item.id)" v-for="item in examineShowList"><span class="text-overflow">{{item.name}}</span></div>
                </div>
                <div v-else style="color: #fff;margin-top: 6px">暂无数据</div>
              </el-scrollbar>
            </div>
            <div class="pitch-on-right">
              <div class="right-icon">
                <i class="iconfont" v-if="role == 1">&#xe904;</i>
                <i style="font-size: 21px" class="iconfont" v-else>&#xe679;</i>
              </div>
              <el-scrollbar class="right-list-scrollbar">
                <div class="right-list" v-if="examineChildrenShowList.class" >
                  <span class="right-list-item text-overflow" :style="{color:lookClassActive === item.id?'#28d7fc':''}" v-for="item in examineChildrenShowList.class" @click="lookPitchClass(item.id)">{{item.name}}</span>
                </div>
                <div v-else style="color: #fff;margin-top: 8px">暂无数据</div>
              </el-scrollbar>
            </div>
            <div class="pitch-on-right" v-if="role==3 && dimensionality==4">
              <div class="right-icon">
                <i class="iconfont" v-if="role == 1">&#xe904;</i>
                <i style="font-size: 21px" class="iconfont" v-else>&#xe61e;</i>
              </div>
              <el-scrollbar class="right-list-scrollbar">
                <div class="right-list" v-if="accountShowList.length && lookLeftActive">
                  <span class="right-list-item text-overflow" v-for="item in accountShowList" >{{item.name}}{{  }}</span>
                </div>
                <div v-else style="color: #fff;margin-top: 8px">暂无数据</div>
              </el-scrollbar>
            </div>
          </div>
          <div class="set-pitch-on-box" v-if="setPitchOnShow">
            <div class="set-pitch-on">
              <div class="set-pitch-top">
                <span>{{role == 1 ? '选择学校' : '选择班级' }}</span>
                <i class="iconfont" @click="setPitchOnShow = false">&#xe623;</i>
              </div>
              <el-checkbox class="all-check" v-if="schoolClassList.length" ref="allCheckedRef" v-model="allChecked" @change="handleCheckAllChange">全选</el-checkbox>
              <div class="set-pitch-mid data-spectaculars-select">
                <div class="mid-right-icon">
                  <i class="iconfont">&#xe674;</i>
                  <i class="iconfont">&#xe674;</i>
                </div>
                <!-- <div class="mid-right-icon mid-right-icon2">
                  <i class="iconfont">&#xe674;</i>
                  <i class="iconfont">&#xe674;</i>
                </div> -->
            
                <el-cascader-panel @change="selectDataChange" @click.native="selectDataClick" v-model="selectData" popper-class="data-spectaculars-select" :props="props" :options="schoolClassList"></el-cascader-panel>
              </div>
              <div class="set-pitch-footer">
                <el-button @click="saveSelect" class="blue-btn">保存</el-button>
                <el-button @click="resetSelect">重置</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spectaculars-chart-box">
      <div class="chart-left">
        <div id="chartMonthLike" :style="{width: '100%', height: '326px', background:'border: 1px solid rgba(67, 154, 255, 0.15)',boxShadow: '0px 0px 40px 0px rgba(12, 21, 48, 0.8)', borderRadius:'4px'}"></div>
        <div id="ageDistribution" :style="{width: '100%', height: '300px', background:'border: 1px solid rgba(67, 154, 255, 0.15)',boxShadow: '0px 0px 40px 0px rgba(12, 21, 48, 0.8)', borderRadius:'4px',marginTop:'14px'}"></div>
        <div id="commentTop" :style="{width: '100%', height: '438px', background:'border: 1px solid rgba(67, 154, 255, 0.15)',boxShadow: '0px 0px 40px 0px rgba(12, 21, 48, 0.8)', borderRadius:'4px',marginTop:'14px'}"></div>
      </div>
      <div class="chart-middle">
        <div class="middle-header">
          <div class="middle-header-title">
            <span>—粉丝总量—</span>
          </div>
          <div class="middle-header-total">
              <span class="text-overflow"><strong>{{allFans}}</strong></span>
          </div>
        </div>
        <div class="middle-footer-table">
          <div class="footer-table-header">
            <div class="header-item one">
              <div class="video"><span></span>视频排行榜</div>
              <el-date-picker
                popper-class="elDatePicker"
                v-model="selectpickData"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @blur="selectDate"
                @change="selectDate">
              </el-date-picker>
            </div>
          </div>
          <el-table  height="600" max-height="600" :data="videoListData" style="width: 100%;"  :header-cell-style="{color:'#fff',fontSize:'14px',fontWeight:'500'}"  @sort-change="onSortChange"  :default-sort = "{'prop': prop, 'order': type}" >
            <el-table-column  width="220"  class-name="column">
              <template slot='header'  slot-scope="scope">
                <span style="margin-left: 30px;">视频</span>
              </template>
              <template slot-scope="scope">
                <div class="table-column" @click="goVideo(scope.row.video_url)">
                <img class="video-image" :src="scope.row.cover_url" alt="">
                <div class="item-right">
                  <span class="text-overflow">{{scope.row.desc || '暂无名字'}}</span>
                  <span class="text-overflow">{{scope.row.video_create_time}}</span>
                </div>
               </div>
              </template>
            </el-table-column>
            <el-table-column prop="student_name" label="学生姓名"  align="center" ></el-table-column>
            <el-table-column label="抖音账号" width="150"  align="center">
              <template slot-scope="scope">
               <a :href="scope.row.account_link" v-if="scope.row.account_link" style="color: #2755aa;" target="_blank">{{ scope.row.unique_id }}</a>
                <span v-else>{{ scope.row.unique_id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="账号" width="110"  align="center">
              <template slot-scope="scope">
                <div class="item-right">
                <span class="user-name">{{scope.row.username}}</span>
                <span class="user-name">{{scope.row.name}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="play_count" label="播放量"  sortable='custom'  align="center" width="86"></el-table-column>
            <el-table-column prop="digg_count" label="点赞量"   sortable='custom' align="center" width="86"></el-table-column>
            <el-table-column prop="comment_count" label="评论量" sortable='custom'   align="center" width="86"></el-table-column>
            <el-table-column prop="video_time" label="发布日期" sortable='custom' width="120"  align="center" ></el-table-column>
            <!-- <el-table-column  label="操作"  align="center">
              <template slot-scope="scope">
                <span class="go-video"><a :href="scope.row.video_url" target="_blank"><i class="iconfont">&#xef92;</i></a></span>
              </template>
            </el-table-column> -->

          </el-table>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="Leaderboard.page"
              layout="prev, pager, next"
              :total="videoTotal">
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="chart-right">

        <div id="dataAnalyse" :style="{width: '100%', height: '410px', background:'border: 1px solid rgba(67, 154, 255, 0.15)',boxShadow: '0px 0px 40px 0px rgba(12, 21, 48, 0.8)', borderRadius:'4px'}"></div>

        <div class="timeTab">
          <div :class="alltimeTabIndex === 1 ? 'timeBtnActive' : 'timeBtn'" @click="selectAllData(1)">总量</div>
          <div :class="alltimeTabIndex === 2 ? 'timeBtnActive' : 'timeBtn'" @click="selectAllData(2)">增量</div>
          <div :class="timeTabIndex === 1 ? 'timeBtnActive' : 'timeBtn'" @click="selectTime(1)">近7天</div>
          <div :class="timeTabIndex === 2 ? 'timeBtnActive' : 'timeBtn'" @click="selectTime(2)">30天</div>
        </div>
        <!-- <div class="timeTab">
          <div :class="timeTabIndex === 1 ? 'timeBtnActive' : 'timeBtn'" @click="selectTime(1)">近7天</div>
          <div :class="timeTabIndex === 2 ? 'timeBtnActive' : 'timeBtn'" @click="selectTime(2)">30天</div>
        </div> -->
        <div class="fans-ranking">
<!--          <div class="timeTab">-->
<!--            <div :class="fansTabIndex === 1 ? 'timeBtnActive' : 'timeBtn'" @click="selectFans(1)">近7天</div>-->
<!--            <div :class="fansTabIndex === 2 ? 'timeBtnActive' : 'timeBtn'" @click="selectFans(2)">30天</div>-->
<!--          </div>-->
          <div class="fans-ranking-header">
            <span></span>
            <span>粉丝排行榜</span>
          </div>
          <div class="fans-ranking-line">
            <div class="ranking-line-item">排榜</div>
            <div class="ranking-line-item">{{getFansTitle()}}</div>
            <div class="ranking-line-item">粉丝量</div>
          </div>
          <el-scrollbar class="ranking-row-scroll">
            <div class="fans-ranking-row" v-for="(item,index) in followerTop">
              <div class="ranking-row-item">
                <img v-if="index === 0" class="rankIcon" src="./../../assets/img/spectaculars/icon_four.png" alt="">
                <img v-if="index === 1" class="rankIcon" src="./../../assets/img/spectaculars/icon_one.png" alt="">
                <img v-if="index === 2" class="rankIcon" src="./../../assets/img/spectaculars/icon_two.png" alt="">
                <img v-if="index === 3" class="rankIcon" src="./../../assets/img/spectaculars/icon_Third.png" alt="">
                <span v-if="index > 3 ">{{index + 1}}</span>
              </div>
              <div class="ranking-row-item">
                <div class="ranking-name">
                  <img :src="item.head_portrait || require('./../../assets/img/image/user_img.png')" alt="">
                  <span class="text-overflow">{{item.name}}</span>
                </div>
              </div>
              <div class="ranking-row-item">
                <span>{{item.value}}</span>
              </div>
            </div>
            <div v-if="!followerTop.length" style="text-align: center">暂无数据</div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>

export default {
  name: "dataSpectaculars",
  data(){
    return {
      alltimeTabIndex:1,
      timeTabIndex:1,
      fansTabIndex:1,
      role:localStorage.getItem('role') || '',
      allFans:'',
      selectTitle:'',
      videoTopList:[],
      weekFollowerTop:[],
      monthFollowerTop:[],
      followerTop:[],
      selectChangeList:[],
      dataAnalysisList:[],//数据分析 全部
      dataAnalysisListadd:[],//数据分析 增量
      dimensionality:1,
      dimensionalityClass:[
        {
          id:1,
          name:'学校维度'
        },
        {
          id:2,
          name:'班级维度'
        },
        {
          id:3,
          name:'学生维度'
        },
        {
          id:4,
          name:'账号维度'
        },
      ],
      lookPitchOnShow:false,
      setPitchOnShow:false,
      lookLeftActive:0,
      lookClassActive:0,
      props: { multiple: true, value:'id', label:'name', children:'class'},
      selectData:[], //当前选择存储
      selectDataLater:[], // 保存之后存储
      schoolClassList:[],
      isAllCheckedList:[],
      allChecked:false,
      collegeList:[],
      examineShowList:[],
      examineChildrenShowList:[],
      examineShowListSave:[],
      accountShowList:[],
      Leaderboard:{
        type:2,
        page:1,
        limit:10,
        sort:'play_count',
        sort_order:'desc',
        start_date:'',
        end_date:''
      },
      videoTotal:0,
      videoListData:[],
      isDatePicker:true,
      selectpickData:'',
      prop:'play_count',
      type:'desc',
    }
  },
  mounted() {
    if(this.role == 1) {
      this.getCollege();
    } else{
      this.dimensionalityClass.splice(0,1);
      this.dimensionality = 2;
      this.getClassList();
    }
    this.getReviewData();
    this.getVideoData()
  },
  methods:{
    goVideo(url){
      if(url){
        window.open(url)
      }
    },
    // 获取到视频排行榜数据
    getVideoData(){
      // reviewVideo
       // 教师端的网络请求用的是$httpteacher 总管理用的是$http
       let httpUrl = this.role == 3 ? this.$httpteacher : this.$http;
       let param={
        ...this.Leaderboard
       }
       if(this.collegeList.length){
          param.ids = JSON.stringify(this.collegeList)
        }
        httpUrl.axiosPost(this.$api.reviewVideo, param, res=>{
          this.videoTotal=res.data.total
            this.videoListData=res.data.list
        })
      //  httpUrl.axiosGetBy(this.$api.reviewVideo,this.Leaderboard,res=>{
      //   console.log(res,"获取到新的值");
      //   this.videoTotal=res.data.total
      //   this.videoListData=res.data.list
      //  })
    },
    // 获取粉丝排行标题
    getFansTitle(){
      switch (this.dimensionality){
        case 1:
          return '学校名称';
          break;
        case 2:
          return '班级名称';
          break;
        case 3:
          return '学生名称';
          break;
        default:
          return '账号名称'
      }
    },
    //全选
    mountedCheckAll(){
      if(this.schoolClassList.length){
        let list = [];
        let leng = this.schoolClassList.length;
       if(this.role==3&& this.dimensionality==4){
        for(let i = 0; i < leng; i++){
          if(this.schoolClassList[i].children && this.schoolClassList[i].children.length>0){
            let leng2 = this.schoolClassList[i].children.length;
            for(let j = 0; j < leng2; j++){
              let list2=[]
              if(this.schoolClassList[i].children[j].children &&this.schoolClassList[i].children[j].children.length>0){
                let leng3 = this.schoolClassList[i].children[j].children.length;
                for(let m = 0; m < leng3; m++){
                  let list3=[]
                  list3.push(this.schoolClassList[i].id)
                  list3.push(this.schoolClassList[i].children[j].id)
                  list3.push(this.schoolClassList[i].children[j].children[m].id)
                  list.push(list3)
                }
              }else{
                  list2.push(this.schoolClassList[i].id)
                  list2.push(this.schoolClassList[i].children[j].id)
                  list.push(list2)
              }
            }
          } else {
            let list2 = [];
            list2.push(this.schoolClassList[i].id)
            list.push(list2)
          }
        }
       }else{
        for(let i = 0; i < leng; i++){
          if(this.schoolClassList[i].class){
            let leng2 = this.schoolClassList[i].class.length;
            for(let j = 0; j < leng2; j++){
              let list2 = [];
              list2.push(this.schoolClassList[i].id)
              list2.push(this.schoolClassList[i].class[j].id)
              list.push(list2)
            }
          } else {
            let list2 = [];
            list2.push(this.schoolClassList[i].id)
            list.push(list2)
          }
        }
       }
        this.selectData = list;
        this.isAllCheckedList = JSON.parse(JSON.stringify(list));
        this.allChecked = true;
      }
    },
    handleCheckAllChange(val){
      if(val){
        this.mountedCheckAll()
      } else {
        this.selectData = []
      }
      this.$nextTick(()=>{
        this.selectDataClick()
      })
    },
    saveSelect(){
      console.log(this.selectData,"selectData");
      // 如果没有选择班级提示
      if (this.selectData.length === 0) {
        this.$message.warning("请至少选择一个班级");
        return;
      }
      // this.examineShowList = [];
      this.lookLeftActive = 0;
      this.lookClassActive=0
      this.examineChildrenShowList = [];
      this.selectDataLater = JSON.parse(JSON.stringify(this.selectData));
      let hash = {};
      let collegeList = [];
      if(this.role==3&& this.dimensionality==4){
      // const firstElements = this.selectData.map(sub => sub[0]).filter((value, index, self) => self.indexOf(value) === index);
      // const secondElements = this.selectData.map(sub => sub[1]).filter(value => value !== undefined).filter((value, index, self) => self.indexOf(value) === index);
      // const thirdElements = this.selectData.map(sub => sub[2]).filter(value => value !== undefined).filter((value, index, self) => self.indexOf(value) === index);
      // let obj={
      //   class_id:firstElements,
      //   student_id:secondElements,
      //   account_id:thirdElements
      // }
      // collegeList.push(obj)
      const groupedData = {};

      this.selectData.forEach(subArray => {
            const classId = subArray[0]; // 获取 class_id
            const studentId = subArray[1]; // 获取 student_id
            const other = subArray[2]; // 获取其他内容

            if (!groupedData[classId]) {
                groupedData[classId] = { class_id: classId, student_id: [], other: [] };
            }

            if (studentId !== undefined) {
                groupedData[classId].student_id.push(studentId);
            }

            if (other !== undefined) {
                groupedData[classId].other.push(other);
            }
        });

        // 将结果转换为数组
         collegeList = Object.values(groupedData).map(({ class_id, student_id, other }) => ({
            class_id,
            student_id: [...new Set(student_id)], // 去重
            account_id: [...new Set(other)] // 去重
        }));
     }else{
       //总管理 与 学管、教师传的字段名不一样
       if(this.role == 1){
        collegeList = this.selectData.reduce((item, next) => {
          hash[next[0]] ? "" : hash[next[0]] = true && item.push({'college_id':next[0],'class_id':[]});
          return item
        }, []);
        collegeList.forEach(item=>{
          this.selectData.forEach(item2=>{
            if(item.college_id === item2[0]){
              if(item2[1]){
                item.class_id.push(item2[1])
              }
            }
          })
        })
      } else {
        collegeList = this.selectData.reduce((item, next) => {
          hash[next[0]] ? "" : hash[next[0]] = true && item.push({'class_id':next[0],'student_id':[]});
          return item
        }, []);
        collegeList.forEach(item=>{
          this.selectData.forEach(item2=>{
            if(item.class_id === item2[0]){
              if(item2[1]){
                item.student_id.push(item2[1])
              }
            }
          })
        })
      }
     }
      //collegeList 选择后传的学校和班级或班级和学生
      this.collegeList = collegeList;
      console.log(" this.collegeList", this.collegeList);
      
      // 点击查看展示的数据处理
      let lookList = [];
      let collegeLength = collegeList.length;
      let schoolLength = this.examineShowListSave.length;
     if(this.role==3 && this.dimensionality==4){
      for(let i = 0; i < collegeLength; i++){
          for(let j = 0; j < schoolLength; j++){
            if(collegeList[i].class_id === this.examineShowListSave[j].id){
              let obj = {
                name:this.examineShowListSave[j].name,
                id:this.examineShowListSave[j].id,
                class:[]
              }
              console.log(obj,collegeList[i],"obj");
              
              if(collegeList[i].student_id && collegeList[i].student_id.length){
                let pLength = collegeList[i].student_id.length;
                console.log(this.examineShowListSave[j].children,"this.examineShowListSave[j].class");
                
                for(let p = 0; p < pLength; p++){
                  let obj2 = this.examineShowListSave[j].children.find(function (classItem){
                    return classItem.id === collegeList[i].student_id[p]
                  })
                  let obj1={
                    name:obj2.name,
                    id:obj2.id,
                    account:[]
                  }
                  console.log("obj2",obj2);
                  
                  if(obj2.children && obj2.children.length){
                    for(let m=0;m<collegeList[i].account_id.length;m++){
                      let obj3=obj2.children.find(function (classItem){
                        return classItem.id === collegeList[i].account_id[m]
                      })
                      if(obj3){
                        obj1.account.push(obj3)
                      }
                    
                    }
                  }
                  obj.class.push(obj1)
                }
              }
              lookList.push(obj)
            }
          }
        }
     }else{
      if(this.role == 1){
        for(let i = 0; i < collegeLength; i++){
          for(let j = 0; j < schoolLength; j++){
            if(collegeList[i].college_id === this.examineShowListSave[j].id){
              let obj = {
                name:this.examineShowListSave[j].name,
                id:this.examineShowListSave[j].id,
                class:[]
              }
              if(collegeList[i].class_id && collegeList[i].class_id.length){
                let pLength = collegeList[i].class_id.length;
                for(let p = 0; p < pLength; p++){
                  let obj2 = this.examineShowListSave[j].class.find(function (classItem){
                    return classItem.id === collegeList[i].class_id[p]
                  })
                  obj.class.push(obj2)
                }
              }
              lookList.push(obj)
            }
          }
        }
      } else {
        for(let i = 0; i < collegeLength; i++){
          for(let j = 0; j < schoolLength; j++){
            if(collegeList[i].class_id === this.examineShowListSave[j].id){
              let obj = {
                name:this.examineShowListSave[j].name,
                id:this.examineShowListSave[j].id,
                class:[]
              }
              if(collegeList[i].student_id && collegeList[i].student_id.length){
                let pLength = collegeList[i].student_id.length;
                for(let p = 0; p < pLength; p++){
                  let obj2 = this.examineShowListSave[j].class.find(function (classItem){
                    return classItem.id === collegeList[i].student_id[p]
                  })
                  obj.class.push(obj2)
                }
              }
              lookList.push(obj)
            }
          }
        }
      }
     }
      
      this.examineShowList = lookList

      this.getReviewData();
      this.getVideoData()
      this.setPitchOnShow = !this.setPitchOnShow
    },
    // 重置
    resetSelect(){
      this.selectData = []
    },
    // 暂无数据div
    selectDataClick(){
      let panel = document.getElementsByClassName('el-cascader-menu');
      let noData = document.getElementsByClassName('no-data')[0];
     if(this.role==3&&this.dimensionality==4 ){
      let noData2=document.getElementsByClassName('no-data2')[0];
      const mid= document.getElementsByClassName('mid-right-icon2')[0];
      let panel22 = document.getElementsByClassName('el-cascader-panel')[0];
      console.log("mid", panel22.children.length);
     
      // if(mid && (panel.length==3 ||noData2 )){
      //   mid.style.display = 'block'
      // }else{
      //   mid.style.display = 'none'
      // }
      
      if(noData2){
        noData2.remove()
        //  mid.style.display = 'none'
      }
      if(panel.length==2){
          if(!noData2){
            this.$nextTick(()=>{
            let panel2 = document.getElementsByClassName('el-cascader-panel')[0];
            let noData2 = document.createElement('div');
            noData2.innerHTML = '暂无数据';
            noData2.className = 'no-data2';
            panel2.appendChild(noData2)
            
           })
          }
       }
     } 
   
      if(panel.length>1){
        if(noData){
          noData.style.display = 'none'
        } 
      } else {
        if(noData){
          noData.style.display = 'block';
         
        } else {
          let panel2 = document.getElementsByClassName('el-cascader-panel')[0];
          let noData2 = document.createElement('div');
          noData2.innerHTML = '暂无数据';
          noData2.className = 'no-data';
          panel2.appendChild(noData2)
        }
      }
    },
    selectDataChange(val){
      if(this.isAllCheckedList.length === this.selectData.length){
        this.allChecked = true
      } else {
        this.allChecked = false
      }
    },
    selectDimensionality(num){
      this.dimensionality = num;
      if(this.role==3&& num==4){
        this.props={ multiple: true, value:'id', label:'name', children:'children'}
        this.getClassList();
      }else{
        this.props={ multiple: true, value:'id', label:'name', children:'class'}
        this.getClassList();
      }
      this.getReviewData()
    },
    lookPitchOnClick(){
      this.lookPitchOnShow = !this.lookPitchOnShow;
    },
    setPitchOnClick(){
      this.setPitchOnShow = !this.setPitchOnShow;
      // if(this.selectDataLater.length){
      //   this.selectData = JSON.parse(JSON.stringify(this.selectDataLater))
      // }
      // 开启弹框默认不全选
      this.selectData = [];
      this.allChecked = false;
      this.$nextTick(()=>{
        let panel1 = document.getElementsByClassName('el-cascader-menu');
        if(panel1.length<2){
          let panel = document.getElementsByClassName('el-cascader-panel')[0];
          let noData = document.createElement('div');
          noData.innerHTML = '暂无数据';
          noData.className = 'no-data';
          panel.appendChild(noData)
        }
      })
    },
    lookPitchSchool(id){
      this.lookLeftActive = id;
      this.examineChildrenShowList = this.examineShowList.find(function (item){
        return item.id === id
      })
      this.accountShowList=[]
      console.log(" this.examineChildrenShowList", this.examineChildrenShowList);
    },
    lookPitchClass(id){
      this.lookClassActive=id
    this.$nextTick(()=>{
      this.accountShowList=this.examineChildrenShowList.class.find(function (item){
        return item.id==id
      }).account
    })
      console.log(this.accountShowList,"  this.accountShowList");
      
    },
    // 总管理获取学院班级
    getCollege(){
      this.$http.axiosGet(this.$api.review_college_class, res=>{
        if(res.code === 200){
          this.examineShowList = JSON.parse(JSON.stringify(res.data));
          this.examineShowListSave = JSON.parse(JSON.stringify(res.data));
          this.schoolClassList = this.getTreeData(res.data);        
          this.mountedCheckAll();
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //去掉空白children
    getTreeData(arr){
      for(var i=0;i<arr.length;i++){
        if(arr[i].class.length < 1){
          arr[i].class=undefined;
        }else {
          this.getTreeData(arr[i]);
        }
      }
      return arr;
    },
    // 教师端获取班级
    getClassList(){
      let httpUrl = null;
      if(this.role == 3){
        httpUrl = this.$httpteacher
      } else {
        httpUrl = this.$http
      }
      httpUrl.axiosGet(this.$api.review_classStudent, res=>{
        if(res.code === 200){
          if(res.data.length){
            let list = JSON.parse(JSON.stringify(res.data).replace(/user/g, 'class'));
            this.examineShowList = JSON.parse(JSON.stringify(list));
            console.log( this.examineShowList," this.examineShowList");
            
            this.examineShowListSave = list;
            this.schoolClassList = this.getTreeData(list);
           if(this.role==3&&this.dimensionality==4){
            this.schoolClassList=this.normalizeChildren(this.schoolClassList,"class")
            console.log("this.schoolClassList1",this.schoolClassList);
           }
            
            this.mountedCheckAll();
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    normalizeChildren(data, childrenKey, level = 0) {
      return data.map(item => {
        const children = item[childrenKey];
        if (children && children.length > 0) { // 限制最多处理到第三层
          item.children = this.normalizeChildren(children, 'account', level + 1);
        } 
        delete item[childrenKey];
        return {
          id: item.id,
          name: item.name,
          ...item
        };
      });
},
    //获取数据
    getReviewData(){
        let param = {
          type : this.dimensionality
        };
        // 教师端的网络请求用的是$httpteacher 总管理用的是$http
        let httpUrl = this.role == 3 ? this.$httpteacher : this.$http;
        if(this.collegeList.length){
          param.ids = JSON.stringify(this.collegeList)
        }
        httpUrl.axiosPost(this.$api.review, param, res=>{
          if(res.code === 200){
            if(res.data.video_top.length > 10){
              let list = [];
              for(let i = 0; i < 10; i++){
                list.push(res.data.video_top[i])
              }
              this.videoTopList = list;
            } else {
              this.videoTopList = res.data.video_top;
            }
            // this.weekFollowerTop = res.data.week_follower_top;
            // this.monthFollowerTop = res.data.month_follower_top;
            if(res.data.follower_top.length > 10){
              let list2 = [];
              for(let i = 0; i < 10; i++){
                list2.push(res.data.follower_top[i])
              }
              this.followerTop = list2;
            } else {
              this.followerTop = res.data.follower_top;
            }
            this.followerTop = res.data.follower_top;
            // 给粉丝总量每三位用逗号分开
            if(res.data.all_fans){
              let famsLength = res.data.all_fans.toString().length;
              let allFans = res.data.all_fans.toString();
              if(famsLength <= 3){
                this.allFans = res.data.all_fans
              } else if(famsLength >= 9){
                this.allFans = '99,999,999+'
              } else {
                let r = famsLength % 3;
                this.allFans = r > 0 ? allFans.slice(0, r) + "," + allFans.slice(r, famsLength).match(/\d{3}/g).join(",") : allFans.slice(r, famsLength).match(/\d{3}/g).join(",");
              }
            } else {
              this.allFans = 0
            }
            let dataAnalysis = [];
            let dataAnalysisListadd=[]
            if(res.data.data_analysis){
              for(let i in res.data.data_analysis){
                let obj = {
                  time:i,
                  play:res.data.data_analysis[i].play_count
                }
                dataAnalysis.push(obj)
              }
            }
            if(res.data.data_analysis_increment){
              for(let i in res.data.data_analysis_increment){
                let obj = {
                  time:i,
                  play:res.data.data_analysis_increment[i].play_count
                }
                dataAnalysisListadd.push(obj)
              }
            }
            this.getChartMonthLike(res.data.like_top);
            this.getAgeDistribution(res.data.age_distribution);
            this.getCommentTop(res.data.comment_top);
            this.dataAnalysisList = dataAnalysis;
            this.dataAnalysisListadd=dataAnalysisListadd;
            this.getDataAnalyse(dataAnalysis);
            window.onresize =()=>{
              this.chartMonthLike.resize();
              this.ageDistribution.resize();
              this.commentTop.resize();
              this.dataAnalyse.resize();
            }
          } else {
            this.videoTopList = [];
            this.weekFollowerTop = [];
            this.monthFollowerTop = [];
            this.followerTop = [];
            this.allFans = 0;
            this.getChartMonthLike([]);
            this.getAgeDistribution([]);
            this.getCommentTop([]);
            this.getDataAnalyse([]);
            this.dataAnalysisList = [];
            this.$message.warning(res.message)
          }
        })
    },
    //月点赞图表
    getChartMonthLike(arr){
      let _this = this;
      let name = [];
      let num  = [];
      let maxNum = 0;
      if(arr.length){
        arr.map(item=>{
          name.push(item.name);
          num.push(Math.abs(item.value));
        })
      } else {
        //没有数据时候的展示
        let leng = 10;
        for(let i = 0; i < leng; i++){
          name.push('');
          num.push(0)
        }
      }
      this.chartMonthLike = this.$echarts.init(document.getElementById("chartMonthLike"));
      this.chartMonthLike.setOption({
        title: {
          text: '总点赞TOP10',
          textStyle:{
            color:'#fff',
            fontStyle:'normal',
            fontSize:16,
            fontWeight:400
          },
          left:30,
          top:10,
          bottom:20,
        },
        tooltip: {
          formatter: "{a} <br/>{b} : {c}",
        },
     
        color:['#E93CA7','#439AFF'],
        legend: {
          padding:[12,24,12,7],
          data:[],
          top:0,
          left:0,
          itemWidth:6,
          itemHeight:6,
          textStyle:{
            color:'#fff',
            fontSize:16,
          }
        },
        grid:{
          containLabel:true,
          bottom:20,
        },
        xAxis: [
            {
              data: name,
              type:'category',
              axisLabel:{
                show:true,
                color:'#FFFFFF',
                fontSize: 12,
                rotate:-40,
              },
              axisTick:{
                show:false
              }
        }
        ],
        yAxis: [
          {
            splitNumber: 5,
            // max:maxNum,
            type:'value',
            splitLine: {
              show: true,
              lineStyle:{
                color: ['rgba(67,154,255,0.2)'],
                width: 1,
                type: 'solid'
              }
            },
            axisLabel:{
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
              formatter:function (value,index){
                if(value >= 10000){
                  return `${value / 10000}W`
                } else {
                  return value
                }
              }
            },
          }
        ],
        series: [{
          name: '总点赞TOP10',
          type: 'bar',
          data: num,
          barWidth:13,
          itemStyle:{
            normal:{
              color: function(params) {
                let colorList = [
                  {
                    c1: '#28B1FF',  //管理
                    c2: '#2B8AFF'
                  },
                  {
                    c1: '#E93CA7',  //实践
                    c2: '#FFAB61'
                  },]
                if(params.dataIndex % 2 === 0){
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    offset: 0,
                    color: colorList[0].c1
                  }, {
                    offset: 1,
                    color: colorList[0].c2
                  }])
                } else {
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    offset: 0,
                    color: colorList[1].c1
                  }, {
                    offset: 1,
                    color: colorList[1].c2
                  }])
                }

                /*  return colorList[params.dataIndex]*/
              }
            }
          }
        }]
      })
    },
    // 粉丝年龄图表
    getAgeDistribution(arr){
      this.ageDistribution = this.$echarts.init(document.getElementById("ageDistribution"));
      let _this = this
      let age = [];
      let num  = [];
      let list = [];
      let jia = 0;
      if(arr.length){
        arr.map(item=>{
          if(item.name !== '50-'){
            jia += item.proportion
          }
          let obj = {
            name:item.name,
            icon:'circle',
          }
          age.push(obj);
          let obj2 = {
            name:item.name,
            value:item.proportion,
          }
          num.push(obj2);
        })
        num[4].value = 100 - jia;
      } else {
        // 没有数据时候的展示
        age[0] = { name:'1-23', icon:'circle' };
        age[1] = { name:'24-30', icon:'circle' };
        age[2] = { name:'31-40', icon:'circle' };
        age[3] = { name:'41-50', icon:'circle' };
        age[4] = { name:'50-', icon:'circle' };
        num[0] = { name:'1-23', value:0 };
        num[1] = { name:'24-30', value:0 };
        num[2] = { name:'31-40', value:0 };
        num[3] = { name:'41-50', value:0 };
        num[4] = { name:'50-', value:0 };
      }
      this.ageDistribution.setOption({
        title: {
          text: '粉丝年龄分布',
          textStyle:{
            color:'#fff',
            fontStyle:'normal',
            fontSize:16,
            fontWeight:400
          },
          left:30,
          top:10
        },
        tooltip : { //提示框组件
          trigger: 'item', //触发类型(饼状图片就是用这个)
          formatter: "{a} <br/>{b} : {d}%", //提示框浮层内容格式器
        },
        color:['#439AFF','#FFAB61','#6B12CC','#E93CA7','#38f9d7'],
        legend: {
          padding:[0,40,0,0],
          //right:100,  //图例组件离右边的距离
          orient : 'horizontal',  //布局  纵向布局 图例标记居文字的左边 vertical则反之
          width:40,      //图行例组件的宽度,默认自适应
          x : 'right',   //图例显示在右边
          y: 'center',   //图例在垂直方向上面显示居中
          itemWidth:10,  //图例标记的图形宽度
          itemHeight:10, //图例标记的图形高度
          data:age,
          textStyle:{
            color:'#fff',
            fontSize:14,
            lineHeight:20
          }
        },
        series: [{
          name: '粉丝年龄分布',
          type: 'pie',
          data: num,
          center:['34%','58%'],
          radius : ['50%', '70%'],
          itemStyle:{
            normal:{
              borderWidth:6,
              borderColor:'rgb(15,12,80)',
              label : {  //饼图图形上的文本标签
                show : true,  //平常不显示
                color:'#fff',
                formatter: function (params) {
                  return params.value + '%'
                }
              },
              labelLine : {     //标签的视觉引导线样式
                show : true  //平常不显示
              },
              color: function(params) {

                let num=params.dataIndex;

                let colorList = [
                  {
                    c1: '#28B1FF',
                    c2: '#2B8AFF'
                  },
                  {
                    c1: '#E93CA7',
                    c2: '#FFAB61'
                  },
                  {
                    c1:'#6B12CC',
                    c2:'#2C6BF8'
                  },{
                    c1:'#614AD3',
                    c2:'#E42C64'
                  },{
                    c1:'#43e97b',
                    c2:'#38f9d7'
                  },{
                    c1:'#83A4D4',
                    c2:'#B6FBFF'
                  },
                  {
                    c1:'#7F7FD5',
                    c2:'#86A8E7'
                  },
                  {
                    c1:'#91EAE5',
                    c2:'#86A8E7'
                  },
                  {
                    c1:'#EEBD89',
                    c2:'#D13ABD'
                  },
                  {
                    c1:'#44A08D',
                    c2:'#093637'
                  },
                  {
                    c1:'#EAD6EE',
                    c2:'#A0F1EA'
                  },
                  {
                    c1:'#373B44',
                    c2:"#4286F4"
                  }
                  ]
                  if(num<colorList.length){
                    return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    offset: 0,
                    color: colorList[num]['c1']

                  }, {
                    offset: 1,
                     color: colorList[num]['c2']
                  }])
                  }


                /*  return colorList[params.dataIndex]*/
              }
            },
            emphasis:{
              label:{
                show : true,
                position : 'center',
                textStyle : {
                  fontSize : '10',
                  fontWeight : 'bold'
                }
              }
            }
          }
        }]
      })
    },
    // 月评论图表
    getCommentTop(arr){
      let _this = this;
      this.commentTop = this.$echarts.init(document.getElementById("commentTop"));
      let name = [];
      let num  = [];
      let maxNum = 0;
      if(arr.length){
        if(arr.length > 8){
          for(let i = 0; i < 8; i++){
            name.push(arr[i].name);
            num.push(arr[i].value);
          }
        } else {
          arr.map(item=>{
            name.push(item.name);
            num.push(item.value);
          });
        }
      } else {
        // 没有数据时候的展示
        let leng = 8;
        for(let i = 0; i < leng; i++){
          name.push('');
          num.push(0)
        }
      }

      this.commentTop.setOption({
        title: {
          text: '总评论TOP8',
          textStyle:{
            color:'#fff',
            fontStyle:'normal',
            fontSize:16,
            fontWeight:400
          },
          left:30,
          top:10
        },
        tooltip: {
          formatter: "{a} <br/>{b} : {c}",
        },
        color:['#E93CA7','#439AFF'],
        legend: {
          padding:[12,24,12,7],
          data:[],
          top:0,
          left:0,
          itemWidth:6,
          itemHeight:6,
          textStyle:{
            color:'#fff',
            fontSize:16,
          }
        },
        grid:{
          containLabel:true
        },
        xAxis: [
          {
            type:'value',
            // max:maxNum,
            splitLine: {
              show: true,
              lineStyle:{
                color: ['rgba(67,154,255,0.2)'],
                width: 1,
                type: 'solid'
              }
            },
            axisLabel:{
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
              formatter:function (value,index){
                if(value >= 10000){
                  return `${value / 10000}W`
                } else {
                  return value
                }
              }
            },
          }
        ],
        yAxis: [
          {
            type:'category',
            data:name,
            axisLabel:{
              show:true,
              color:'#FFFFFF',
              fontSize: 12,
              rotate:40
            },
            axisTick:{
              show:false
            }
          }
        ],
        series: [{
          name: '总评论TOP8',
          type: 'bar',
          data: num,
          barWidth:13,
          itemStyle:{
            normal:{
              color: function(params) {
                let colorList = [
                  {
                    c1: '#28B1FF',
                    c2: '#2B8AFF'
                  },
                  {
                    c1: '#E93CA7',
                    c2: '#FFAB61'
                  },
                ]
                if(params.dataIndex === 0 ||params.dataIndex === 4 || params.dataIndex === 7){
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    offset: 0,
                    color: colorList[0].c1
                  }, {
                    offset: 1,
                    color: colorList[0].c2
                  }])
                } else {
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    offset: 0,
                    color: colorList[1].c1
                  }, {
                    offset: 1,
                    color: colorList[1].c2
                  }])
                }
              }
            }
          }
        }]
      })
    },
    getDataAnalyse(arr){
      let time = []; // 时间
      let play = []; //播放量
      let maxNum = 0;

      if(arr.length){
        // 近七天
        if(this.timeTabIndex === 1){
          console.log("11111");
          if(arr.length > 7){
            // 近七天需要截取最后七条数据
            let weekList = arr.slice(-7);
            weekList.map(item=>{
              time.push(item.time);
              play.push(item.play);
            })
          } else {
            // 全部数据不满7天就全部展示
            arr.map(item=>{
              time.push(item.time);
              play.push(item.play);
            })
          }
        } else {
          console.log("2222");
          // 30天
          arr.map(item=>{
            time.push(item.time);
            play.push(item.play);
          })
        }
      } else {
        // 没有数据时候的展示
        // console.log("吴数据");
        if(this.timeTabIndex === 1){
          for(let i = 6; i >= 0; i--){
            time.push(this.getDay(-i))
          }
        } else {
          for(let i = 29; i >= 0; i--){
            time.push(this.getDay(-i))
          }
        }
      }
      this.dataAnalyse = this.$echarts.init(document.getElementById("dataAnalyse"));
      this.dataAnalyse.setOption({
        tooltip: {
          trigger: 'axis',
        },
        title: {
          text: '播放量分析',
          textStyle:{
            color:'#fff',
            fontStyle:'normal',
            fontSize:16,
            fontWeight:400
          },
          left:30,
          top:60
        },
        color:['#E93CA7'],
        legend: {
          icon:'rect ',
          data:['播放量'],
          padding:[0,0,10,0],
          x:'center',
          y:'bottom',
          // legend:{
          //   x:'right',
          //   y:'top',
          //   data:['点赞量','评论量','转发量'],
          //   textStyle:{
          //     fontSize: 14,
          //     color: '#fff'
          //   },
          // },
          itemWidth:20,
          itemHeight:3,
          textStyle:{
            color:'#fff',
            fontSize:16,
          }
        },
        xAxis: [
          {
            data: time,
            type:'category',
            boundaryGap:false,
            axisLabel:{
              show:true,
              color:'#FFFFFF',
              fontSize: 12,
            },
            axisTick:{
              show:false
            }
          }
        ],
        grid:{
          containLabel:true,
          top:110
        },
        yAxis: [
          {
            // max:maxNum,
            type:'value',
            splitLine: {
              show: true,
              lineStyle:{
                color: ['#439aff33'],
                width: 1,
                type: 'solid'
              }
            },
            axisLabel:{
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
              formatter:function (value,index){
                if(value >= 10000){
                  return `${value / 10000}W`
                } else {
                  return value
                }
              }
            },
          }
        ],
        series : [
          {
            name:'播放量',
            symbol:'none', //这句就是去掉点的
            showSymbol:false,
            smooth:true, //这句就是让曲线变平滑的
            type:'line',
            data:play,
            barWidth:13,
            itemStyle:{
              normal:{

              }
            },
            areaStyle:{
              normal: {
                color:new this.$echarts.graphic.LinearGradient(0,1,0,0,[{
                  offset:0,
                  color:'#614ad31a'
                },{
                  offset:1,
                  color:'#e42c64cc'
                }])
              }
            }
          },
        ]
      })
    },
    selectTime(num){
      this.timeTabIndex = num;
      if(this.alltimeTabIndex==1){
      this.getDataAnalyse(this.dataAnalysisList)
    }else{
      this.getDataAnalyse(this.dataAnalysisListadd)
    }
    },
    selectAllData(num){
      this.alltimeTabIndex=num
    if(this.alltimeTabIndex==1){
      this.getDataAnalyse(this.dataAnalysisList)
    }else{
      this.getDataAnalyse(this.dataAnalysisListadd)
    }

    },
    selectFans(num){
      if(num === 1){
        this.followerTop = this.weekFollowerTop;
      } else {
        this.followerTop = this.monthFollowerTop;
      }
      this.fansTabIndex = num;
    },
    // 获取七天或三十天日期
    getDay(day){
      let today = new Date();
      let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tMonth+"-"+tDate;
    },
    doHandleMonth(month){
      let m = month;
      if(month.toString().length == 1){
        m = "0" + month;
      }
      return m;
    },
    handleCurrentChange(val){
      this.Leaderboard.page=val
      this.getVideoData()
    },
    sortVideo(sort,sort_order){
      this.Leaderboard.sort=sort;
      this.Leaderboard.sort_order=sort_order
      this.getVideoData()
    },
    selectDate(){
      // if(item==null){
      //   item=[]
      // }
      // console.log(this.selectpickData,"kkkk");
      // console.log(item,"hhhh");
      if(!this.selectpickData){
        this.selectpickData=[]
      }

      this.Leaderboard.start_date=this.selectpickData[0] || '';
      this.Leaderboard.end_date=this.selectpickData[1] || '';

      //   this.Leaderboard.start_date='';
      // this.Leaderboard.end_date='';


      this.getVideoData()

    },
    onSortChange({ prop, order }){
      console.log(prop,order);
      this.Leaderboard.sort=prop=="video_time"?"video_create_time":prop;
      this.Leaderboard.sort_order=order=='ascending'?'asc':'desc'
      this.getVideoData()
    },


  }
}
</script>

<style scoped lang="scss">
.spectaculars-box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: radial-gradient(circle, #101671, #0F0841);
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .spectaculars-header{
    display: flex;
    flex-direction: column;
    margin-top: 38px;
    .header-title{
      text-align: center;
      background-image: linear-gradient(180deg,#00f5ff,#00f5ff,#00baff);
      -webkit-background-clip:text;
      color: transparent;
      position: relative;
      span{
        font-size: 26px;
        //color: #3CC5EE;
        font-weight: bold;
        line-height: 1;
        display: inline-block;
        box-shadow: 0px 5px 91px 26px rgba(18, 72, 251, 0.6);
        background: rgba(18, 72, 251,0.3);
      }
    }
    .header-title-img{
      height: 48px;
      position: relative;
      display: flex;
      justify-content: center;
      .img-box{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 2%;
        img{
          width: 100%;
          height: 48px;
        }
        .dimensionality-class{
          position: absolute;
          left: 1.64%;
          display: flex;
          top: -39px;
          .dimensionality-item{
            width: 134px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            color: #709EFB;
            text-shadow: 0 0 12px rgba(255,255,255,0.5);
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .dimensionalityItemActive{
            background-image: url("./../../assets/img/spectaculars/dimensionality-img.png");
            color: #fff;
          }
        }
        .quadrangle-look{
          font-size: 28px;
          position: absolute;
          left: 30px;
          bottom: 0;
          background-image: linear-gradient(180deg,#00f5ff,#00f5ff,#00baff);
          -webkit-background-clip:text;
          color: transparent;
          cursor: pointer;
          text-shadow: 0 0 12px rgba(255,255,255,0.4);
        }
        .quadrangle-set{
          position: absolute;
          right: 16px;
          top: -30px;
          font-size: 28px;
          background-image: linear-gradient(180deg,#00f5ff,#00f5ff,#00baff);
          -webkit-background-clip:text;
          color: transparent;
          cursor: pointer;
        }
        .look-pitch-on{
          box-sizing: border-box;
          padding: 0 2px 22px 22px;
          position: absolute;
          left: 80px;
          top: 22px;
          border: 2px solid #28D7FC;
          background: rgba(29,32,117,0.8);
          border-radius: 6px;
          // width: 1200px;
          z-index: 99;
          display: flex;
          .closeIcon{
            color: #28D7FC;
            font-size: 14px;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 10px;
          }
          .mid-right-icon{
            position: absolute;
            left: 230px;
            top: 80px;
            display: flex;
            align-items: center;
            i{
              font-size: 14px;
              color: #09C1E1;
              &:nth-child(1){
                color: #2D6099;
              }
            }
          }
          .pitch-on-left,.pitch-on-right{
            overflow: hidden;
            width: 200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            &.pitch-on-left{
              margin-right: 30px;
            }
            &.pitch-on-right{
              margin-right: 30px;
            }
            .left-icon, .right-icon{
              text-align: center;
              line-height: 1;
              margin: 22px 0 22px;
              i{
                margin-right: 20px;
                text-align: center;
                font-size: 24px;
                color: #28D7FC;
                text-shadow: 0 0 20px rgba(255,255,255,0.8);
              }
            }
            .left-list-scrollbar, .right-list-scrollbar{
              height: 340px;
              ::v-deep.el-scrollbar__wrap {
                overflow-x: hidden;
                //margin-right: 0!important;
              }
              ::v-deep.is-vertical{
                .el-scrollbar__thumb{
                  width: 7px!important;
                  background-color: #16D0FF!important;
                }
              }
            }
            .left-list{
              width: 236px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: 20px;
              .left-list-item{
                width: 236px;
                line-height: 32px;
                height: 32px;
                color: #fff;
                font-size: 12px;
                border-radius: 2px;
                //border: 1px solid rgba(9, 183, 219, 0.17);
                text-align: center;
                box-shadow:rgba(11, 234, 235,0.8) 0px 0px 8px inset;
                margin-top: 10px;
                cursor: pointer;
                padding: 0 20px;
                box-sizing: border-box;
                span{
                  display: inline-block;
                  width: 100%;
                }
                &:first-of-type{
                  margin-top: 0;
                }
              }
              .listItemActive{
                background: #28D7FC;
              }
            }
            .right-list{
              margin-right: 20px;
              width: 236px;
              box-sizing: border-box;
              padding: 0 20px 20px;
              box-shadow:rgba(11, 234, 235,0.8) 0px 0px 8px inset;
              display: flex;
              flex-direction: column;
              min-height: 340px;
              .right-list-item{
                text-align: center;
                font-size: 12px;
                color: #fff;
                margin-top: 20px;
              }
            }
          }
        }
        .set-pitch-on-box{
          background: rgba(0,0,0,0.2);
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          .set-pitch-on{
            box-sizing: border-box;
            border: 2px solid #28D7FC;
            background: rgba(29,32,117,0.8);
            border-radius: 6px;
            // width: 900px;
            display: flex;
            flex-direction: column;
            padding: 22px 12px;
            padding-left: 40px;
            ::v-deep.el-checkbox .is-checked .el-checkbox__inner{
              //border-radius: 50%;
              border-color: #09C1E1;
              background-color: #09C1E1;
              &::after{
                border-color: #1D2075;
              }
            }
            .set-pitch-top{
              display: flex;
              justify-content: space-between;
              span{
                padding-left: 24px;
                line-height: 30px;
                font-size: 16px;
                color: #fff;
                display: inline-block;
                width: 138px;
                height: 26px;
                background-image: url("./../../assets/img/spectaculars/set-pitch-img.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                font-weight: bold;
              }
              i{
                color: #28D7FC;
                font-size: 14px;
                cursor: pointer;
              }
            }
            .all-check{
              margin-top:34px;
              ::v-deep.el-checkbox__label{
                color: #fff;
                font-size: 14px;
                font-weight: bold;
              }
            }
            .set-pitch-mid{
              display: flex;
              margin-top: 20px;
              position: relative;
              .mid-right-icon{
                position: absolute;
                left: 300px;
                top: 12px;
                display: flex;
                align-items: center;
                i{
                  font-size: 14px;
                  color: #09C1E1;
                  &:nth-child(1){
                    color: #2D6099;
                  }
                }
              }
              .mid-right-icon2{
                left: calc(68% - 2px);
              }
              .pitch-on-left,.pitch-on-right{
                overflow: hidden;
                width: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
                &.pitch-on-left{
                  margin-right: 30px;
                  align-items: start;
                }
                .left-list-scrollbar, .right-list-scrollbar{
                  height: 340px;
                  ::v-deep.el-scrollbar__wrap {
                    overflow-x: hidden;
                  }
                  ::v-deep.is-vertical{
                    .el-scrollbar__thumb{
                      width: 7px!important;
                      background-color: #16D0FF!important;
                    }
                  }
                  ::v-deep.el-checkbox{
                    .el-checkbox__label{
                      display: none;
                    }
                  }
                }
                .left-list{
                  //width: 236px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  margin-right: 20px;
                  .left-list-item{
                    display: flex;
                    align-items: center;
                    //border: 1px solid rgba(9, 183, 219, 0.17);
                    margin-top: 10px;
                    box-sizing: border-box;
                    .text-overflow{
                      width: 230px;
                      display: inline-block;
                      line-height: 32px;
                      height: 32px;
                      color: #fff;
                      font-size: 12px;
                      border-radius: 2px;
                      text-align: center;
                      box-shadow:rgba(11, 234, 235,0.8) 0px 0px 8px inset;
                      box-sizing: border-box;
                      cursor: pointer;
                      padding: 0 20px;
                      margin-left: 8px;
                    }
                    &:first-of-type{
                      margin-top: 0;
                    }
                    ::v-deep.el-checkbox{
                      .el-checkbox__label{
                        display: none;
                      }
                    }
                  }
                  .listItemActive{
                    .text-overflow{
                      background: #28D7FC;
                    }

                  }
                }
                .right-list{
                  margin-right: 20px;
                  width: 236px;
                  box-sizing: border-box;
                  padding: 0 20px 20px;
                  box-shadow:rgba(11, 234, 235,0.8) 0px 0px 8px inset;
                  display: flex;
                  flex-direction: column;
                  min-height: 340px;
                  .right-list-item{
                    font-size: 12px;
                    color: #fff;
                    margin-left: 20px;
                  }
                }
              }
            }
            .set-pitch-footer{
              text-align: center;
              margin-top: 20px;
              .el-button{
                padding: 8px 35px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .header-quadrangle{
        display: flex;
        position: absolute;
        left:calc(50% + 200px);
        top: -22px;
        .quadrangle{
          width: 18px;
          height: 34px;
          background: linear-gradient(176deg, #3CC5EE 0%, #0C0F67 100%);
          border-radius: 1px;
          transform: skewX(-20deg);
          margin-right: 6px;
        }
      }
    }
    .header-class{
      padding: 6px 40px 24px 40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .selectClassBtn{
        margin-right: 24px;
        background: #1D2088;
        color: #FFFFFF;
        font-size: 14px;
        padding: 12px 29px;
        border: none;
      }
      span{
        color: #FFFFFF;
        font-size: 14px;
        margin-right: 30px;
      }
    }
  }
  .spectaculars-chart-box{
    padding: 46px 40px 20px;
    display: flex;
    height: calc(100vh - 94px);
    .chart-left, .chart-middle, .chart-right{
      display: flex;
      flex-direction: column;
    }
    .chart-left{
      width: 24%;
    }
    .chart-middle{
      margin: 0 12px;
      flex: 1;
      width: 1%;
      color: #fff;
      display: flex;
      flex-direction: column;
      .middle-header{
        display: flex;
        flex-direction: column;
        align-items: center;
        .middle-header-title{
          span{
            font-size: 20px;
            color: #fff;
            font-weight: bold;
            text-shadow: 0px 0 20px rgba(255,255,255,0.5);
            line-height: 1;
          }
        }
        .middle-header-total{
          width: 100%;
          height: 214px;
          display: flex;
          line-height: 1;
          align-items: center;
          font-size: 30px;
          justify-content: center;
          background: url("./../../assets/img/spectaculars/zheng.png") no-repeat;
          background-size:100% 100%;
          strong{
            font-size: 50px;
          }
        }
      }
      .middle-footer-table{
        display: flex;
        flex: 1;
        height: 1%;
        border-radius: 4px;
        flex-direction: column;
        background: rgba(27, 18, 103, 0.5);
        border: 1px solid rgba(67, 154, 255, 0.15);
        box-shadow: 0px 0px 40px 0px rgba(12, 21, 48, 0.8);
        .footer-table-header{
            // display: flex;
            .one{

              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 14px;
              padding-top: 20px;
              box-sizing: border-box;
              .video{
                font-size: 16px;
              color: #fff;
                span{
                  margin-left: 30px;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #E93CA7;
                    border-radius: 50%;
                    margin-right: 10px;

}
              }
              .el-date-picker{
                background-color: transparent;
                // ::v-deep .el-date-editor.el-input__inner{
                //   width: 246px;
                // }
                // ::v-deep .el-date-editor{
                //   background-color: pink;
                // }

              }

            }
            .two{
              display: flex;
              justify-content: flex-end;
              .header-item{
              font-size: 16px;
              color: #fff;
              display: flex;
              // width: 11%;
              align-items: center;
              padding: 10px 9px;
              justify-content: center;
              box-sizing: border-box;
              &:nth-child(1){
                padding-right: 140px;

              }
              &:nth-child(2){
                padding-right: 53px;

              }
              &:nth-child(3){
                padding-right: 63px;
              }
              &:nth-child(7){
                padding-right: 17px;
              }
              &:nth-child(8){
                // width: 20%;
                padding-right: 30px;
              }
            }
            }

          }
        .table-scroll-box{
          display: flex;
          flex-direction: column;
          flex: 1;
          height: 1%;
          ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        .footer-table-line{
          display: flex;
          &:nth-child(odd){
            background: linear-gradient(88deg, rgba(51, 78, 193, 0.27) 0%, rgba(24, 15, 97, 0.22) 97%);
          }
          .table-line-item{
            padding: 10px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 10%;
            span{
              text-align: center;
              color: #fff;
              font-size: 14px;
              i{
                font-size: 22px;
                color: #FFAB61;
                background: #fff;
                border-radius: 50%;
                cursor: pointer;
              }
            }
            &:nth-child(6){
              width: 11%!important;
              margin-left: 6px;
            }
            &:nth-child(1){
              width: 30%!important;
              img{
                max-width: 43px;
                max-height: 54px;
                margin-right: 8px;
              }
              .item-right{
                display: flex;
                flex-direction: column;
                span{
                  width: 140px;
                  text-align: left;
                  &:nth-child(2){
                    color: #2B55AA;
                    margin-top: 4px;
                  }
                }
              }
            }
            &:nth-child(3){
              width: 20%;
              display: flex;
              flex-direction: column;
              span{
                width: 120px;
                &:nth-child(2){
                  margin-top: 4px;
                  color: #2B55AA;
                }
              }
            }
          }
        }

      }
    }
    .chart-right{
      width: 27%;
      color: #fff;
      position: relative;
      .timeTab{
        width: 120px;
        display: flex;
        flex-wrap: wrap;
        border-radius: 4px;
        position: absolute;
        top: 14px;
        right: 20px;

        div{
          width: 40px;
          &:nth-child(1){
            border-radius: 4px 0px 0px 4px ;
            margin-bottom: 10px;
          }
          &:nth-child(2){
            border-radius: 0 4px 4px 0 ;
            margin-bottom: 10px;
          }
          &:nth-child(3){
            border-radius: 4px 0px 0px 4px ;
            margin-bottom: 10px;
          }
          &:nth-child(4){
            border-radius: 0 4px 4px 0 ;
            margin-bottom: 10px;
          }
        }
        .timeBtn{
          cursor: pointer;
          padding: 6px 8px;
          background: #0C1530;
          color: #224B84;

          display: inline-block;
        }
        .timeBtnActive{
          cursor: pointer;
          padding: 6px 8px;
          background: #439AFF;
          color: #fff;

        }
      }
      .fans-ranking{
        margin-top: 14px;
        background: rgba(27, 18, 103, 0.5);
        border: 1px solid rgba(67, 154, 255, 0.15);
        box-shadow: 0px 0px 40px 0px rgba(12, 21, 48, 0.8);
        border-radius:8px;
        display: flex;
        flex: 1;
        height: 1%;
        flex-direction: column;
        position: relative;
        .fans-ranking-header{
          padding: 20px 22px;
          display: flex;
          align-items: center;
          span{
            line-height: 1;
            &:nth-child(1){
              width: 8px;
              height: 8px;
              background: linear-gradient(130deg, rgba(233,60,167,0.7), rgba(27, 18, 103, 0.4));
              border-radius: 50%;
              margin-right: 10px;
            }
            &:nth-child(2){
              font-size: 16px;
              color: #fff;
            }
          }
        }
        .fans-ranking-line{
          display: flex;
          color: #fff;
          font-size: 16px;
          margin-bottom: 10px;
          .ranking-line-item{
            text-align: center;
            &:nth-child(1){
              width: 22%;
            }
            &:nth-child(2){
              display: flex;
              width: 56%;
            }
            &:nth-child(3){
              width: 22%;
            }
          }
        }
        .ranking-row-scroll{
          display: flex;
          flex-direction: column;
          flex: 1;
          height: 1%;
          ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        .fans-ranking-row{
          &:nth-child(odd){
            background: linear-gradient(88deg, rgba(51, 78, 193, 0.27) 0%, rgba(24, 15, 97, 0.22) 97%);
          }
          display: flex;
          padding: 10px 0;
          .ranking-row-item{
            display: flex;
            align-items: center;
            &:nth-child(1){
              width: 22%;
              display: flex;
              justify-content: center;
              align-items: center;
              .rankIcon{
                max-width: 17px;
                max-height: 22px;
              }
            }
            &:nth-child(2){
              display: flex;
              width: 56%;
              .ranking-name{
                overflow: hidden;
                display: flex;
                align-items: center;
                img{
                  max-width: 23px;
                  max-height: 23px;
                  border-radius: 50%;
                  margin-right: 10px;
                }
                span{
                  font-size: 14px;
                  color: #FFFFFF;
                }
              }
            }
            &:nth-child(3){
              width: 22%;
              display: flex;
              justify-content: center;
              align-items: center;
              span{
                font-size: 14px;
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }
  }
}

 //教师端选择班级弹框样式
::v-deep.teacherSelectClassBox{
  .classList{
    height: 300px;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-button{
    padding: 9px 36px;
  }
  .el-dialog__body{
    padding: 10px 24px 20px 10px;
  }
  .el-table{
    .el-table__header-wrapper{
      border-radius: 10px;
      .el-checkbox{
        &:after{
          content: '全选';
          font-size: 12px;
          color: #333333;
          margin-left: 9px;
        }
      }
    }
  }
  .is-checked{
    .el-checkbox__inner{
      background-color: #2F54EB;
      border-color: #2F54EB;
    }
  }
  .is-indeterminate{
    .el-checkbox__inner{
      background-color: #2F54EB;
      border-color: #2F54EB;
    }
  }
}
#chartMonthLike,#ageDistribution,#commentTop,#dataAnalyse{
  &:after{
    content: '';
    width: 8px;
    height: 8px;
    background: linear-gradient(130deg, rgba(233,60,167,0.7), rgba(27, 18, 103, 0.4));
    border-radius: 50%;
    position: absolute;
    left: 20px;
    top: 68px;
  }
}

  // color: #217aff;
  //     border: 1px solid #217aff;
      .up:hover {
        border-bottom: 6px solid #217aff;
      }
      .down:hover {
        border-top: 6px solid #217aff;
      }

    .opacity-5 {
      opacity: 1 !important;
     border-bottom: 6px solid #217aff;

    }
    .opacity-1 {
      opacity: 1 !important;
      border-top: 6px solid #217aff;
    }
    .box-icon {
      height: 30px;
      margin-top: 15px;
      margin-left: 5px;
      .up {
        width: 0px; /*设置宽高为0，所以div的内容为空，从才能形成三角形尖角*/
        height: 0px;
        opacity: 0.5;
        border-bottom: 6px solid #a3a5b3;
        border-left: 4px solid transparent; /*transparent 表示透明*/
        border-right: 4px solid transparent;
        margin-bottom: 4px;
      }
      .down {
        width: 0px;
        height: 0px;
        opacity: 0.5;
        border-top: 6px solid #a3a5b3;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
      }
    }
    .box-icon div {
      height: 10px;
      margin-left: 4px;

    }
    .pagination{
      display: flex;
      justify-content: flex-end;
      .el-pagination{
        background-color: transparent;
        color: #fff;
      }

  }

  ::v-deep .btn-prev{
    background-color: transparent;
    color: #fff;
  }
  ::v-deep .el-pager li{
    background-color: transparent;
    color: #fff;
  }
  ::v-deep .el-pager li.active{
    color: #00baff;
  }
  ::v-deep .el-pagination .btn-prev{
    background-color: transparent !important;
    color: #fff !important;
  }
  ::v-deep .el-pagination .btn-next{
    background-color: transparent !important;
    color: #fff !important;

  }
  // ::v-deep .el-icon .el-icon-arrow-righ{
  //   color: #fff;
  //   background-color: #439aff33;
  // }
  ::v-deep .el-input__inner {
	  background-color: transparent !important;
	  border-color: rgba(67, 154, 255, 0.15);
	  // box-shadow: 1px 1px 5px 1px  RGB(128,255,255,0.8) inset;
	  // height: 30px;
	}
  ::v-deep .el-range-input{
    background-color: transparent !important;
    color: #fff;
  }
  ::v-deep .el-range-separator{
    color: #fff;
  }
//   .elDatePicker.el-picker-panel {
//   color: #fff;//设置当前面板的月份的字体为白色，记为1
//   background: #002450;//定义整体面板的颜色
//   border: 1px solid #1384b4;//定义整体面板的轮廓
//   .el-picker-panel__icon-btn {//设置年份月份调节按钮颜色，记为2
//     color: #ffffff;
//    }
//   .el-date-picker__header-label{//设置年月显示颜色，记为3
//   	color: #ffffff;
//   }
//   .el-date-table th {//设置星期颜色，记为4
//       color:#ffffff;
//   }

// }

// 重写表格的样式
.el-table{
  background-color: rgb(22,18,102);
  border: none;
}
.table-container{
  height: 500px;
}
.table-column{
  width: 100%;
  height: 54px;
  cursor: pointer;

  display: flex;
  .video-image{
  max-width: 43px;
  max-height: 54px;
  margin-right: 8px;
}
  .item-right{
    display: flex;
    flex-direction: column;
    span{
      width: 140px;
      white-space: nowrap; /* 防止文本换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 使用省略号显示超出部分 */
      text-align: left;
      &:nth-child(2){
        color: #2B55AA;
        margin-top: 4px;
      }
    }
  }

}
.go-video{
  text-align: center;
  color: #fff;
  font-size: 14px;
  i{
    font-size: 22px;
    color: #FFAB61;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
  }
}

::v-deep .el-table thead tr>th{
  width: 100%;
    background-color: rgb(22,18,102);
    border: none;
}
// 更改表格每行背景颜色
:deep(.el-table) tbody tr>td{
    // background-color: rgb(26,28,119);
    color: #fff;
    border: none;
}
// 设置鼠标经过时背景颜色
::v-deep .el-table tr:nth-child(even) {
  background-color: rgb(26,28,119) !important;
}
::v-deep .el-table tr:nth-child(odd) {
  background-color: rgb(22,18,102) !important;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover >td{
    background-color:transparent !important;
}

::v-deep .el-table th.el-table__cell.is-leaf {
  border: none !important;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background-color: rgb(22,18,102);
}
// ::v-deep .el-table .el-table__body-wrapper tbody tr:nth-child(even) {
//   background-color: #f2f2f2; /* 设置偶数行的背景色 */
// }




div ::v-deep.el-table::before, .el-table--group::after, .el-table--border::after{
  background-color: unset !important;
  border: none !important;
}
.el-table--border tr,td{
       border: none!important;
    }
    .el-table::before{
      height:0;
    }
::v-deep .el-table colgroup col[name='gutter']{
    width: 0px ;
    display: none !important;
}


.el-table {

	 :deep(.el-table__body-wrapper::-webkit-scrollbar) {
	    width: 3px; /*滚动条宽度*/
	    height: 6px; /*滚动条高度*/
	}
	/*定义滚动条轨道 内阴影+圆角*/
	:deep(.el-table__body-wrapper::-webkit-scrollbar-track)  {
	    box-shadow: 0px 1px 3px #071e4a inset; /*滚动条的背景区域的内阴影*/
	    border-radius: 10px; /*滚动条的背景区域的圆角*/
	    background-color: #071e4a; /*滚动条的背景颜色*/
	}
	/*定义滑块 内阴影+圆角*/
	:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb){
	    box-shadow: 0px 1px 3px #595bbb inset; /*滚动条的内阴影*/
	    border-radius: 10px; /*滚动条的圆角*/
	    background-color: rgb(26,28,119); /*滚动条的背景颜色*/
	}
  :deep(.el-table__body-wrapper::-webkit-scrollbar-corner){
  background: rgb(7,30,74);
}
}

.item-right{
  .user-name{
    color: #2B55AA;
  }
}
// ::v-deep .el-cascader-menu{
//   min-width: 238px;
//   border-right: none;
// }
// ::v-deep  .el-cascader-menu{
// // width: 238px;
// // display: block;
// //     margin-top: 6px;
// //     margin-left: 34px;
// &:nth-child(2){
//   -webkit-box-shadow: rgba(11, 234, 235, 0.8) 0px 0px 8px inset !important;
  
// }


// }
// // 
// ::v-deep .data-spectaculars-select .el-cascader-panel .el-cascader-menu:nth-child(2) .el-cascader-menu__wrap .el-cascader-menu__list{

// }


</style>
